import { Check } from "lucide-react"

// 1 → 2 → 3 progress for the payment-request workflow. A step is clickable
// once the user has already reached it; later steps stay locked until the
// current step validates.
const PaymentWizardStepper = ({ steps, current, maxReached, onStepClick }) => (
  <div className="prc-steps" role="list">
    {steps.map((step, idx) => {
      const stepNo = idx + 1
      const active = stepNo === current
      const done = stepNo < current
      const reachable = stepNo <= maxReached
      return (
        <div key={step.key} style={{ display: "contents" }}>
          <button
            type="button"
            role="listitem"
            className={`prc-step${active ? " is-active" : ""}${done ? " is-done" : ""}${reachable ? " is-clickable" : ""}`}
            onClick={() => reachable && onStepClick(stepNo)}
            disabled={!reachable}
            aria-current={active ? "step" : undefined}
          >
            <span className="prc-step-num">{done ? <Check aria-hidden size={14} /> : stepNo}</span>
            <span>
              <span className="prc-step-label">{step.label}</span>
              {step.hint && <span className="prc-step-hint">{step.hint}</span>}
            </span>
          </button>
          {stepNo !== steps.length && <span className={`prc-step-line${done ? " is-done" : ""}`} />}
        </div>
      )
    })}
  </div>
)

export default PaymentWizardStepper
